<template>
  <div class="pipenetwork">
    <div :id="`${modelactiveCount === 1 ? 'left2' : 'left'}`">
      <!-- 安全运行天数 -->
      <div class="run-time">
        <Title :text="basicData.SafeOperationDays.Title[0]" :engText="basicData.SafeOperationDays.Title[1]"></Title>
        <div class="left-content">
          <div class="run">
            <div class="icon"></div>
            <div class="content">
              <div>运行开始时间</div>
              <div>{{basicData.SafeOperationDays.StartTime}}</div>
            </div>
          </div>
          <div class="time">
            <div class="icon"></div>
            <div class="content">
              <div>已运行时间</div>
              <div>{{basicData.SafeOperationDays.ElapsedTime}}天</div>
            </div>
          </div>
        </div>
      </div>
      <div class="border-Row"></div>
      <!--报警事件  -->
      <div class="warning-event">
        <Title :text="basicData.AlarmEvent.Title[0]" :engText="basicData.AlarmEvent.Title[1]"></Title>
        <div class="tab-content">
          <div class="thead">
            <div class="tr">
              <div class="th" v-for="(item,i) in basicData.AlarmEvent.table.thead" :key="i">{{item}}</div>
            </div>
          </div>
          <div class="tbody">
            <div class="tr" v-for="item in basicData.AlarmEvent.table.tbody" :key="item.i">
              <div class="td">{{item.i}}</div>
              <div class="td">{{item.CheckPoint}}</div>
              <div class="td">{{item.Type}}</div>
              <div class="td">{{item.Time}}</div>
              <div class="td">
                <div class="icon"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="border-Row" v-if="basicData.option.pipenetwork[0].active"></div>
      <!--设备状态统计  -->
      <div class="placeholder-border" v-if="basicData.option.pipenetwork[0].active">
        <DeviceStatus></DeviceStatus>
      </div>
      <div class="border-Row" v-if="basicData.option.pipenetwork[1].active"></div>
      <!-- 成本目标 -->
      <div class="placeholder-border" v-if="basicData.option.pipenetwork[1].active">
        <CostTarget></CostTarget>
      </div>
      <div class="border-Row"    v-if="a(2)[0] === 'left' && a(2)[1] "></div>
      <!-- 能耗分布 -->
      <div class="placeholder-border" v-if="a(2)[0] === 'left' && a(2)[1]">
        <CarbonEmission></CarbonEmission>
      </div>
      <div class="border-Row"   v-if="a(3)[0] === 'left' && a(3)[1]" ></div>
      <!-- 建筑能耗 -->
      <div class="placeholder-border" v-if="a(3)[0] === 'left' && a(3)[1]">
        <BuildingEnergyConsumption />
      </div>
      <div class="border-Row"    v-if="a(4)[0] === 'left' && a(4)[1]"></div>
      <!-- 用能趋势分析 -->
      <div class="placeholder-border"   v-if="a(4)[0] === 'left' && a(4)[1]">
        <EnergyConsumptionTrend />
      </div>
    </div>
    <div id="bottom">
      <div class="border-column"  v-if="a(2)[0] === 'right' && a(2)[1] "></div>
      <div class="placeholder-border" v-if="a(2)[0] === 'right' && a(2)[1] ">
        <CarbonEmission></CarbonEmission>
      </div>
      <div class="border-column" v-if="a(3)[0] === 'right' && a(3)[1]"></div>
      <div class="placeholder-border" v-if="a(3)[0] === 'right' && a(3)[1]">
        <!-- 占位 -->
        <BuildingEnergyConsumption />
      </div>
      <div class="border-column" v-if="a(4)[0] === 'right' && a(4)[1]"></div>
      <div class="placeholder-border" v-if="a(4)[0] === 'right' && a(4)[1]">
        <EnergyConsumptionTrend />
      </div>
    </div>
  </div>
</template>


<script>
  import { mapState,mapActions } from 'pinia' //引入映射函数
  import useStore from '@/store/index' //引入store
  import Title from '../components/title/index.vue';
  import DeviceStatus from '@/moduleComponents/pipeNetwork/DeviceStatus.vue'
  import CostTarget from '@/moduleComponents/pipeNetwork/CostTarget.vue'
  import BuildingEnergyConsumption from '@/moduleComponents/pipeNetwork/BuildingEnergyConsumption.vue'
  import CarbonEmission from '@/moduleComponents/pipeNetwork/CarbonEmission.vue'
  import EnergyConsumptionTrend from '@/moduleComponents/pipeNetwork/EnergyConsumptionTrend.vue'
  export default {
    components: {
      Title,
      // 模块组件
      DeviceStatus,
      CarbonEmission,
      BuildingEnergyConsumption,
      EnergyConsumptionTrend,
      CostTarget
    },
    computed:{
      ...mapState(useStore,['pipenetwork','basicData']),
      modelactiveCount(){
      this.modelState = JSON.parse(JSON.stringify(this.basicData.option['pipenetwork']))
        let count = 0
        this.modelState.forEach(item =>{
          if(item.active){
            count++;
          }
        })
        return  count
    }
    },
    data () {
      return {
        modelState:[]
      }
    },
    methods: {
        ...mapActions(useStore, ['changeTagList']),
        a(a){
          let num = 0;
          for (let x = 0; x < this.basicData.option.pipenetwork.length; x++) {
            if(x <= a  &&  this.basicData.option.pipenetwork[x].active === true){
              num = num+1;
            }
          }
          if(num <= 2 ){
            return ['left',this.basicData.option.pipenetwork[a].active]
          }else if(num > 2){
            return ['right',this.basicData.option.pipenetwork[a].active]
          }
        }
        
    },
    mounted () {
    }
  }
  </script>

<style scoped>
.pipenetwork{
  width: 100%;
  height: 100%;
}

#left{
  width: 338px;
  height: calc(100vh - 100px);
  /* background: red; */
  position: absolute;
  top: 82px;
  left: 18px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  
}
 .run-time{
  height: 110px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* background-color: #3d91ff; */
}
 .warning-event{
  /* height: 216px; */
  flex: .8;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
 .warning-event .tab-content{
  flex: 1;
  width: 100%;
  margin-top: 7px;
  display: flex;
  flex-direction: column;
  overflow:hidden;
}
 .warning-event .tab-content .thead{
  border-bottom: 1.5px solid #bdd3ff24;
  box-sizing: border-box;
  margin-bottom: 2px;
}
 .warning-event .tab-content .thead .tr{
  background-color: #093aa35c;
}
 .warning-event .tab-content .tbody .tr .td:nth-child(5) .icon{
  width: 21px;
	height: 13px;
  background:url('@/assets/img/查看.png') no-repeat;
  background-size: 100% 100%;
}

 .run-time .left-content{
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
 .run-time .left-content >div{
  width: 155px;
  height: 65px;
  background: url('@/assets/img/bgd3.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
 .run-time .left-content .run .icon{
  width: 27px;
  height: 27px;
  background: url('@/assets/img/video-icon.png') no-repeat;
  background-size: 100% 100%;
}
 .run-time .left-content .time .icon{
  width: 27px;
  height: 27px;
  background: url('@/assets/img/time.png') no-repeat;
  background-size: 100% 100%;
}
 .run-time .left-content .run .content,
 .run-time .left-content .time .content{
  width: 109px;
  height: 49px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
 .run-time .left-content .run .content >div:nth-child(1),
 .run-time .left-content .time .content >div:nth-child(1){
  font-size: 13px;
  color: #7b8fbb;
}
 .run-time .left-content .run .content >div:nth-child(2),
 .run-time .left-content .time .content >div:nth-child(2){
  font-size: 17px;
  margin-top: 5px;
}
#bottom{
  /* width: calc(100vw - 328px - 40px); */
  height: 276px;
  /* background: darkcyan; */
  position: absolute;
  bottom: 20px;
  left: 350px;
  overflow: hidden;
  display: flex;
}
#bottom .placeholder-border{
  width: 338px;
  height: 100% !important;
  overflow: hidden;
  display: flex;
}
</style>